import { LICENSE_PRODUCT_SMARTDENT } from './LicenseProductConstant';

export const LicenseConstant = {
    GET_MANAGER_GROUP_INFO_BY_COMPANY_ID: 'GET_MANAGER_GROUP_INFO_BY_COMPANY_ID',
    GET_LICENSE_BY_COMPANY_ID: 'GET_LICENSE_BY_COMPANY_ID',
    UPDATE_LICENSE_BY_COMPANY_ID: 'UPDATE_LICENSE_BY_COMPANY_ID',
};

export const LicenseIds = [
    { "id": "App-SmartDentFiveD", "name": "SMARTDent 5D Upgrade" },
    { "id": "App-FaceAnalyzer", "name": "RAYFace SW Upgrade" },
    { "id": LICENSE_PRODUCT_SMARTDENT.licenseAppId, "name": LICENSE_PRODUCT_SMARTDENT.name },
]
